import { connect } from 'react-redux';

import ManagerMarket from './ManagerMarket.jsx';

export default connect()(ManagerMarket);
